import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import DropDown from '../modules/Dropdown';
import DataTable from './GridDataTable';
import tableConfig from '../config/cataloguesTable';
import filterConfig from '../config/cataloguesFilter';
import { updateTableOnFilterChange } from '../helpers/dispatchProps';
import { catalogueStateKey } from './../helpers/catalogueUtils';
import * as catalogueActions from './../actions/catalogue';

/**
 * Reducer state key
 * @type {string}
 */
const stateKey = 'catalogues';

/**
 * Catalogues page
 *
 * @param {{}} props
 * @constructor
 */
function SalesCatalogues(props) {
    return (
        <div className="table__CataloguesList">
            <div className="sales__filter">
                <DropDown
                    stateKey={stateKey}
                    onSelect={updateTableOnFilterChange(catalogueStateKey, tableConfig.url)}
                    {...filterConfig}
                />
            </div>
            <DataTable
                stateKey={catalogueStateKey}
                config={tableConfig}
                onDidMount={props.updateCatalogueTableIfNeeded}
                errorMessage="No sales found"
            />
        </div>
    );
}

SalesCatalogues.propTypes = {
    updateCatalogueTableIfNeeded: PropTypes.func.isRequired
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators(catalogueActions, dispatch);
}

export default connect(null, mapDispatchToProps)(SalesCatalogues);



// WEBPACK FOOTER //
// ./src/js/containers/SalesCatalogues.js